import React from 'react';
import ICellProps, { ITranchRow } from './ICellProps';
import { BodyCell } from '@dealroadshow/uikit/core/components/Table/DataTable';
import { formatDataCell, getTrancheFieldWithPercent } from '@/finsight/ui/components/deals/helpers';
import Product from '@/finsight/domain/Product';

import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';

const getCell = ({ row: tranche }: ITranchRow, dealProductId: string) => {
  const decimals = (Product.isAbsProductOnly([dealProductId]) && tranche.weightedAverageLife < 1) ? 3 : 2;

  return formatDataCell(
    getTrancheFieldWithPercent(tranche.coupon, decimals),
  );
};

const CouponCell = ({
  rowIndex,
  tranche,
  dealProductId,
}: ICellProps) => (
  <BodyCell
    name="CouponCell"
    className={ alignStyles.alignRight }
    rowIndex={ rowIndex }
    rowData={ tranche }
    cellCallback={ (trancheRow) => getCell(trancheRow, dealProductId) }
  />
);

export default CouponCell;
